var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M385.894,322.193c-0.11-0.095-0.169-0.232-0.176-0.378c-0.123-2.66-1.723-28.757-17.705-46.635 c-13.521-15.125,0.347-4.332,6.365,0.532c0.483,0.39,1.147-0.181,0.831-0.715c-4.242-7.172-14.886-26.127-11.196-29.817 c3.489-3.489,10.693,13.825,13.91,22.22c0.233,0.608,1.142,0.391,1.074-0.256c-0.927-8.888-2.277-27.474,2.73-26.821 c4.958,0.647,3.573,25.203,2.594,37.221c-0.054,0.666,0.894,0.846,1.088,0.206c2.237-7.395,6.495-18.323,11.492-15.428 c7.397,4.286-10.888,19.334-9.745,35.666C388.275,313.996,388.572,324.499,385.894,322.193z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M395.491,324.607c0.055-0.007,0.126-0.246,0.097-0.428c-3.49-22.116,19.932-38.197,36.38-46.158 c3.659-1.771,7.46-3.605,10.585-6.321c-6.098,0.406-12.182,2.961-18.024,4.918c-0.77,0.258-1.175-0.54-0.511-1.001 c7.459-5.182,28.235-24.241,22.25-29.789c-2.706-2.508-17.619,17.382-21.13,20.949c-0.566,0.574-1.473,0.063-1.075-0.604 c4.631-7.749,6.159-32.187,1.474-31.889c-1.989,0.126-2.74,11.579-3.782,16.235c-1.953,8.726-5.616,16.923-9.443,24.949 c-0.338,0.708-1.517,0.587-1.341-0.12c1.33-5.342,1.824-21.011-4.749-19.881c-4.768,0.82-4.005,10.043-4.05,14.988 c-0.08,8.774-0.813,17.767-4.59,25.584C395.011,301.363,391.805,325.047,395.491,324.607z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M390.186,327.059c0.074-0.064,0.114-0.156,0.118-0.253c0.082-1.785,1.156-19.303,11.885-31.305 c9.076-10.153-0.233-2.908-4.273,0.357c-0.324,0.262-0.77-0.121-0.557-0.48c2.847-4.814,9.992-17.538,7.515-20.015 c-2.342-2.342-7.178,9.28-9.337,14.915c-0.156,0.408-0.766,0.263-0.721-0.172c0.622-5.966,1.528-18.442-1.832-18.004 c-3.328,0.434-2.398,16.918-1.741,24.985c0.036,0.447-0.6,0.568-0.73,0.138c-1.501-4.964-4.359-12.299-7.714-10.356 c-4.965,2.877,7.309,12.978,6.542,23.941C388.587,321.557,388.388,328.607,390.186,327.059z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M402.277,376.31c5.525-20.599,9.163-49.609,9.163-56.755h-41.207 c0,7.146,3.638,36.156,9.163,56.755c1.015,3.786,4.456,6.409,8.376,6.409h6.128C397.821,382.719,401.262,380.096,402.277,376.31z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M410.252,333.192c0.307-2.505,0.557-4.789,0.747-6.793h-40.326 c0.191,2.004,0.441,4.289,0.748,6.793H410.252z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60.203,
    y: 190.843,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 168.1606 429.4393)",
    style: {
      fill: "#F5F5F5"
    },
    width: 47.754,
    height: 47.754
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M69.416,233.988h29.328c2.543,0,4.604-2.061,4.604-4.604v-29.328c0-2.543-2.061-4.604-4.604-4.604 H69.416c-2.543,0-4.604,2.061-4.604,4.604v29.328C64.812,231.926,66.874,233.988,69.416,233.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M92.032,195.452c-0.277,1.31-1.446,2.302-2.835,2.302H78.964c-1.39,0-2.558-0.992-2.835-2.302 H92.032z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.203,
    y: 238.597,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 168.1606 524.9472)",
    style: {
      fill: "#F0F0F0"
    },
    width: 47.754,
    height: 47.754
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M69.416,281.741h29.328c2.543,0,4.604-2.061,4.604-4.604V247.81c0-2.543-2.061-4.604-4.604-4.604 H69.416c-2.543,0-4.604,2.061-4.604,4.604v29.328C64.812,279.68,66.874,281.741,69.416,281.741z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M92.032,243.206c-0.277,1.31-1.446,2.302-2.835,2.302H78.964c-1.39,0-2.558-0.992-2.835-2.302 H92.032z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.203,
    y: 286.351,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 168.1605 620.4551)",
    style: {
      fill: "#F5F5F5"
    },
    width: 47.754,
    height: 47.754
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M69.416,329.495h29.328c2.543,0,4.604-2.061,4.604-4.604v-29.328c0-2.543-2.061-4.604-4.604-4.604 H69.416c-2.543,0-4.604,2.061-4.604,4.604v29.328C64.812,327.434,66.874,329.495,69.416,329.495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M92.031,290.96c-0.277,1.31-1.446,2.302-2.835,2.302H78.964c-1.39,0-2.558-0.992-2.835-2.302 H92.031z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.203,
    y: 334.104,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 168.1604 715.963)",
    style: {
      fill: "#F0F0F0"
    },
    width: 47.754,
    height: 47.754
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M69.416,377.249h29.328c2.543,0,4.604-2.061,4.604-4.604v-29.328c0-2.543-2.061-4.604-4.604-4.604 H69.416c-2.543,0-4.604,2.061-4.604,4.604v29.328C64.812,375.188,66.874,377.249,69.416,377.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M92.031,338.714c-0.277,1.31-1.446,2.302-2.835,2.302H78.964c-1.39,0-2.558-0.992-2.835-2.302 H92.031z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.353,
    y: 190.843,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 114.5562 572.7012)",
    style: {
      fill: "#E6E6E6"
    },
    width: 5.85,
    height: 191.016
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392.218,
    y: 91.76,
    style: {
      fill: "#F0F0F0"
    },
    width: 46.469,
    height: 46.469
  }), /*#__PURE__*/React.createElement("rect", {
    x: 438.687,
    y: 91.76,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 879.5717 229.9889)",
    style: {
      fill: "#E6E6E6"
    },
    width: 2.197,
    height: 46.469
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.424,
    y: 95.965,
    style: {
      fill: "#E6E6E6"
    },
    width: 38.058,
    height: 38.058
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.165,
    y: 99.707,
    style: {
      fill: "#FAFAFA"
    },
    width: 30.575,
    height: 30.575
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 409.797,
    y: 145.649,
    style: {
      fill: "#F0F0F0"
    },
    width: 29.684,
    height: 49.245
  }), /*#__PURE__*/React.createElement("rect", {
    x: 439.481,
    y: 145.649,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 880.3653 340.5424)",
    style: {
      fill: "#E6E6E6"
    },
    width: 1.404,
    height: 49.245
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.483,
    y: 150.105,
    style: {
      fill: "#E6E6E6"
    },
    width: 24.311,
    height: 40.332
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.874,
    y: 154.07,
    style: {
      fill: "#FAFAFA"
    },
    width: 19.531,
    height: 32.402
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#E0E0E0"
    },
    cx: 359.32,
    cy: 104.111,
    rx: 20.841,
    ry: 13.859
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EBEBEB"
    },
    cx: 360.742,
    cy: 104.111,
    rx: 20.841,
    ry: 13.859
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FAFAFA"
    },
    cx: 360.742,
    cy: 104.111,
    rx: 16.292,
    ry: 10.834
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M423.264,337.815c15.017-34.287,13.164-74.711-4.973-108.495 c-4.671-8.701-10.545-17.154-18.956-23.115c-8.411-5.961-19.743-9.098-29.735-6.301c-11.358,3.179-18.533,12.867-26.04,21.185 c-7.507,8.318-18.122,16.383-29.942,14.398c-7.039-1.182-12.839-5.74-18.047-10.292c-53.35-46.636-87.077-112.445-150.25-147.255 c-13.985-7.706-30.829-13.777-46.097-9.286c-16.735,4.923-26.184,21.047-29.919,36.737c-5.812,24.417-1.626,50.434,8.32,74.086 c9.946,23.652,25.421,45.169,42.448,65.314c44.099,52.174,101.513,97.496,170.038,117.403 c22.943,6.665,47.225,10.402,70.853,7.589c23.628-2.813,46.597-12.674,61.207-29.581 C421.899,341.773,423.264,337.815,423.264,337.815z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M423.264,337.815c15.017-34.287,13.164-74.711-4.973-108.495 c-4.671-8.701-10.545-17.154-18.956-23.115c-8.411-5.961-19.743-9.098-29.735-6.301c-11.358,3.179-18.533,12.867-26.04,21.185 c-7.507,8.318-18.122,16.383-29.942,14.398c-7.039-1.182-12.839-5.74-18.047-10.292c-53.35-46.636-87.077-112.445-150.25-147.255 c-13.985-7.706-30.829-13.777-46.097-9.286c-16.735,4.923-26.184,21.047-29.919,36.737c-5.812,24.417-1.626,50.434,8.32,74.086 c9.946,23.652,25.421,45.169,42.448,65.314c44.099,52.174,101.513,97.496,170.038,117.403 c22.943,6.665,47.225,10.402,70.853,7.589c23.628-2.813,46.597-12.674,61.207-29.581 C421.899,341.773,423.264,337.815,423.264,337.815z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 415.693,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M179.535,410.647v3.344c0,1.732,1.404,3.136,3.136,3.136h119.925 c1.595,0,2.888-1.293,2.888-2.889v-3.219c0-1.595-1.293-2.888-2.888-2.888h-29.823c-3.388,0-5.958-3.053-5.38-6.391 l10.461-60.439h-68.115l-29.165,64.536C179.889,407.348,179.535,408.988,179.535,410.647z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M179.836,408.013c-0.2,0.865-0.306,1.743-0.306,2.634v3.339 c0,1.73,1.41,3.14,3.14,3.14h119.929c1.597,0,2.887-1.291,2.887-2.887v-3.22c0-1.597-1.291-2.887-2.887-2.887H272.77 c-0.386,0-0.758-0.04-1.117-0.12H179.836z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M176.716,405.837l29.165-64.536h3.856l-29.165,64.536c-0.683,1.512-1.037,3.152-1.037,4.811 v3.344c0,1.732,1.404,3.136,3.136,3.136h-3.856c-1.732,0-3.136-1.404-3.136-3.136v-3.344 C175.68,408.988,176.033,407.348,176.716,405.837z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.716,405.837l29.165-64.536h3.856l-29.165,64.536c-0.683,1.512-1.037,3.152-1.037,4.811v3.344 c0,1.732,1.404,3.136,3.136,3.136h-3.856c-1.732,0-3.136-1.404-3.136-3.136v-3.344 C175.68,408.988,176.033,407.348,176.716,405.837z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "209.737,341.3 277.853,341.3 275.183,356.723 202.768,356.723  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M105.386,348.074H396.01c5.868,0,10.208-4.757,9.695-10.625l-18.373-210.005 c-0.513-5.868-5.686-10.625-11.554-10.625H85.154c-5.868,0-10.209,4.757-9.695,10.625L93.831,337.45 C94.345,343.317,99.518,348.074,105.386,348.074z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M403.718,314.74l1.987,22.71c0.513,5.868-3.827,10.625-9.695,10.625H105.386 c-5.868,0-11.041-4.757-11.554-10.625l-1.987-22.71H403.718z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M102.101,308.325h290.238c3.182,0,5.535-2.579,5.257-5.761l-15.185-173.569 c-0.279-3.182-3.083-5.761-6.265-5.761H85.908c-3.182,0-5.535,2.579-5.257,5.761l15.185,173.569 C96.115,305.746,98.919,308.325,102.101,308.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M102.101,308.325h290.238c3.182,0,5.535-2.579,5.257-5.761l-15.185-173.569 c-0.279-3.182-3.083-5.761-6.265-5.761H85.908c-3.182,0-5.535,2.579-5.257,5.761l15.185,173.569 C96.115,305.746,98.919,308.325,102.101,308.325z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M78.728,116.82h6.426c-5.868,0-10.209,4.757-9.695,10.625L93.831,337.45 c0.513,5.868,5.686,10.625,11.554,10.625H98.96c-5.868,0-11.041-4.757-11.554-10.625L69.032,127.444 C68.519,121.577,72.86,116.82,78.728,116.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#407BFF"
    },
    d: "M78.728,116.82h6.426c-5.868,0-10.209,4.757-9.695,10.625L93.831,337.45 c0.513,5.868,5.686,10.625,11.554,10.625H98.96c-5.868,0-11.041-4.757-11.554-10.625L69.032,127.444 C68.519,121.577,72.86,116.82,78.728,116.82z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "89.805,123.234 100.969,123.234 140.311,308.325 129.148,308.325  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "151.594,308.325 112.252,123.234 154.195,123.234 193.538,308.325  "
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M403.718,314.74l1.987,22.71c0.513,5.868-3.827,10.625-9.695,10.625H105.386 c-5.868,0-11.041-4.757-11.554-10.625l-1.987-22.71H403.718z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M78.728,117.02h6.426c-5.868,0-10.209,4.757-9.695,10.625L93.831,337.65 c0.513,5.868,5.686,10.625,11.554,10.625H98.96c-5.868,0-11.041-4.757-11.554-10.625L69.032,127.644 C68.519,121.777,72.86,117.02,78.728,117.02z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Plant"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M114.827,393.484c-0.039,0.061,0.287,0.355-0.822,0.427c-2.731,0.176-7.55,0.123-9.293-2.193 c-2.487-3.308,3.469-3.149,2.944-4.995c-0.525-1.845-6.979-0.164-8.152-2.787c-1.173-2.624,3.473-2.224,3.297-3.585 c-0.176-1.361-5.118,0.533-6.648-2.242c-1.529-2.776,2.699-1.377,2.041-2.527c-0.658-1.149-5.939-5.87-3.71-7.009 c2.229-1.139,7.176,3.804,8.841,4.304c1.665,0.5,2.2-4.484,4.36-2.876c2.16,1.609,0.49,9.154,3.039,10.021 c1.898,0.646,0.931-2.019,3.296-1.975C117.233,378.106,117.982,388.608,114.827,393.484z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M114.827,393.484c-0.039,0.061,0.287,0.355-0.822,0.427c-2.731,0.176-7.55,0.123-9.293-2.193 c-2.487-3.308,3.469-3.149,2.944-4.995c-0.525-1.845-6.979-0.164-8.152-2.787c-1.173-2.624,3.473-2.224,3.297-3.585 c-0.176-1.361-5.118,0.533-6.648-2.242c-1.529-2.776,2.699-1.377,2.041-2.527c-0.658-1.149-5.939-5.87-3.71-7.009 c2.229-1.139,7.176,3.804,8.841,4.304c1.665,0.5,2.2-4.484,4.36-2.876c2.16,1.609,0.49,9.154,3.039,10.021 c1.898,0.646,0.931-2.019,3.296-1.975C117.233,378.106,117.982,388.608,114.827,393.484z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M116.134,396.424c2.107,0.133,5.794-1.668,7.291-3.51c1.52-1.87-2.569-0.848-2.088-2.348 c0.481-1.5,5.408-0.16,6.421-2.293c1.013-2.134-2.598-1.792-2.407-2.897c0.191-1.105,3.9-0.716,5.196-2.975 c1.295-2.259-2.033-1.108-1.477-2.043c0.556-0.935,4.833-4.787,3.154-5.702c-1.679-0.916-5.707,3.115-7.016,3.527 c-1.308,0.412-1.482-2.501-3.219-1.188c-1.737,1.314-0.748,7.431-2.756,8.145c-1.495,0.531-0.749-2.217-2.471-1.591 C113.747,384.646,115.279,396.37,116.134,396.424z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M116.134,396.424c2.107,0.133,5.794-1.668,7.291-3.51c1.52-1.87-2.569-0.848-2.088-2.348 c0.481-1.5,5.408-0.16,6.421-2.293c1.013-2.134-2.598-1.792-2.407-2.897c0.191-1.105,3.9-0.716,5.196-2.975 c1.295-2.259-2.033-1.108-1.477-2.043c0.556-0.935,4.833-4.787,3.154-5.702c-1.679-0.916-5.707,3.115-7.016,3.527 c-1.308,0.412-1.482-2.501-3.219-1.188c-1.737,1.314-0.748,7.431-2.756,8.145c-1.495,0.531-0.749-2.217-2.471-1.591 C113.747,384.646,115.279,396.37,116.134,396.424z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M112.351,368.777c-0.088,0.134,0.617,0.858-1.804,0.859c-5.961,0.001-16.469-0.831-20.2-6.404 c-5.326-7.957,7.658-6.715,6.567-11.028c-1.091-4.312-15.215-1.405-17.695-7.599c-2.48-6.194,7.64-4.591,7.297-7.739 c-0.344-3.149-11.178,0.47-14.43-6.126c-3.252-6.595,5.926-2.763,4.525-5.497c-1.401-2.734-12.777-14.347-7.882-16.631 c4.895-2.284,15.537,9.787,19.153,11.18c3.615,1.393,4.93-9.966,9.593-5.956c4.663,4.01,0.797,21.08,6.33,23.445 c4.121,1.762,2.09-4.496,7.246-4.047C118.056,333.843,119.377,358.053,112.351,368.777z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M112.351,368.777c-0.088,0.134,0.617,0.858-1.804,0.859c-5.961,0.001-16.469-0.831-20.2-6.404 c-5.326-7.957,7.658-6.715,6.567-11.028c-1.091-4.312-15.215-1.405-17.695-7.599c-2.48-6.194,7.64-4.591,7.297-7.739 c-0.344-3.149-11.178,0.47-14.43-6.126c-3.252-6.595,5.926-2.763,4.525-5.497c-1.401-2.734-12.777-14.347-7.882-16.631 c4.895-2.284,15.537,9.787,19.153,11.18c3.615,1.393,4.93-9.966,9.593-5.956c4.663,4.01,0.797,21.08,6.33,23.445 c4.121,1.762,2.09-4.496,7.246-4.047C118.056,333.843,119.377,358.053,112.351,368.777z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M119.131,375.276c4.891,0.308,13.451-3.871,16.927-8.15c3.527-4.341-5.964-1.968-4.847-5.45 c1.117-3.482,12.554-0.371,14.907-5.324c2.353-4.954-6.032-4.159-5.588-6.724c0.444-2.565,9.055-1.662,12.062-6.906 c3.007-5.243-4.719-2.571-3.43-4.742c1.29-2.171,11.219-11.113,7.321-13.238c-3.898-2.126-13.249,7.23-16.287,8.187 c-3.037,0.957-3.441-5.807-7.472-2.757c-4.032,3.05-1.737,17.252-6.398,18.908c-3.471,1.233-1.738-5.147-5.736-3.693 C113.59,347.933,117.145,375.151,119.131,375.276z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M119.131,375.276c4.891,0.308,13.451-3.871,16.927-8.15c3.527-4.341-5.964-1.968-4.847-5.45 c1.117-3.482,12.554-0.371,14.907-5.324c2.353-4.954-6.032-4.159-5.588-6.724c0.444-2.565,9.055-1.662,12.062-6.906 c3.007-5.243-4.719-2.571-3.43-4.742c1.29-2.171,11.219-11.113,7.321-13.238c-3.898-2.126-13.249,7.23-16.287,8.187 c-3.037,0.957-3.441-5.807-7.472-2.757c-4.032,3.05-1.737,17.252-6.398,18.908c-3.471,1.233-1.738-5.147-5.736-3.693 C113.59,347.933,117.145,375.151,119.131,375.276z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M115.95,390.022c0.01,0,0.021-0.001,0.032-0.001c0.213-0.017,0.372-0.204,0.355-0.417 c-3.249-40.178-25.613-57.37-25.838-57.539c-0.171-0.128-0.414-0.093-0.542,0.078 c-0.128,0.171-0.094,0.414,0.077,0.542c0.223,0.167,22.311,17.172,25.53,56.981 C115.58,389.868,115.75,390.022,115.95,390.022z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M95.511,337.833c0.157,0,0.306-0.097,0.364-0.253c0.074-0.201-0.028-0.423-0.228-0.498 c-0.141-0.053-3.526-1.278-9.194-0.315c-0.211,0.036-0.353,0.236-0.317,0.447c0.036,0.211,0.236,0.354,0.447,0.317 c5.447-0.924,8.762,0.266,8.795,0.277C95.421,337.826,95.467,337.833,95.511,337.833z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M99.569,342.863c0.205,0,0.376-0.16,0.387-0.368 c0.614-12.086-5.999-21.818-6.066-21.916c-0.121-0.176-0.363-0.22-0.539-0.099c-0.176,0.121-0.221,0.363-0.099,0.539 c0.065,0.095,6.53,9.621,5.929,21.436c-0.011,0.213,0.154,0.396,0.367,0.406 C99.556,342.863,99.562,342.863,99.569,342.863z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M106.009,353.377c0.098,0,0.195-0.036,0.27-0.111c0.153-0.149,0.156-0.394,0.007-0.548 c-0.05-0.051-5.036-5.053-11.92-2.9c-0.204,0.064-0.318,0.281-0.254,0.486c0.064,0.204,0.281,0.319,0.485,0.254 c6.436-2.015,11.088,2.654,11.134,2.702C105.807,353.338,105.908,353.377,106.009,353.377z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M109.302,360.662c0.145,0,0.283-0.082,0.35-0.221c0.119-0.25,2.905-6.225,1.861-14.943 c-0.026-0.212-0.211-0.367-0.431-0.338c-0.212,0.025-0.364,0.218-0.339,0.43c1.016,8.483-1.763,14.458-1.791,14.517 c-0.092,0.193-0.009,0.424,0.183,0.516C109.189,360.65,109.246,360.662,109.302,360.662z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M115.21,404.295c0.201,0,0.371-0.156,0.386-0.359l0.936-10.568 c2.922-35.147,28.052-58.105,28.306-58.332c0.159-0.143,0.173-0.388,0.03-0.547c-0.144-0.159-0.388-0.172-0.547-0.03 c-0.256,0.23-25.612,23.383-28.56,58.849l-0.936,10.572c-0.015,0.213,0.145,0.399,0.358,0.414 C115.191,404.295,115.2,404.295,115.21,404.295z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M134.335,347.854c0.021,0,0.042-0.002,0.064-0.005c0.034-0.005,0.076-0.021,0.115-0.039 l0.127-0.045c3.215-1.184,6.776-1.721,10.024-1.517c0.217,0.02,0.398-0.148,0.411-0.362 c0.014-0.213-0.149-0.397-0.362-0.411c-3.354-0.21-7.026,0.343-10.341,1.563l-0.131,0.048 c-0.023,0.008-0.046,0.017-0.068,0.029c-0.155,0.071-0.25,0.24-0.221,0.416 C133.985,347.72,134.149,347.854,134.335,347.854z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M130.734,352.249c0.006,0,0.013,0,0.019-0.001c0.214-0.01,0.378-0.192,0.368-0.405 c-0.51-10.43,5.222-18.76,5.28-18.842c0.122-0.175,0.08-0.417-0.095-0.539c-0.177-0.122-0.417-0.079-0.539,0.095 c-0.059,0.085-5.942,8.622-5.419,19.324C130.358,352.087,130.529,352.249,130.734,352.249z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M126.964,358.124c0.094,0,0.189-0.035,0.264-0.104c0.041-0.039,4.121-3.748,9.797-1.984 c0.205,0.065,0.421-0.051,0.485-0.255c0.063-0.204-0.051-0.421-0.255-0.485c-6.119-1.904-10.378,1.991-10.556,2.158 c-0.156,0.146-0.164,0.39-0.019,0.547C126.757,358.083,126.86,358.124,126.964,358.124z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M122.084,367.862c0.056,0,0.112-0.012,0.165-0.037c0.193-0.092,0.276-0.322,0.185-0.515 c-0.025-0.053-2.47-5.357-1.557-12.826c0.026-0.212-0.125-0.405-0.337-0.431c-0.213-0.035-0.406,0.125-0.431,0.337 c-0.942,7.704,1.52,13.027,1.625,13.25C121.8,367.78,121.939,367.862,122.084,367.862z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M115.624,398.043c0.023,0,0.048-0.002,0.072-0.007c0.21-0.039,0.349-0.241,0.309-0.452 c-2.594-13.848-10.475-19.891-10.555-19.951c-0.171-0.128-0.413-0.092-0.542,0.078 c-0.128,0.171-0.093,0.414,0.077,0.542c0.077,0.058,7.723,5.939,10.259,19.473 C115.278,397.913,115.441,398.043,115.624,398.043z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M107.476,380.515c0.158,0,0.306-0.098,0.364-0.254 c0.074-0.201-0.028-0.423-0.228-0.497c-0.063-0.023-1.573-0.572-4.074-0.146c-0.211,0.036-0.353,0.236-0.317,0.447 c0.035,0.21,0.237,0.355,0.447,0.317c2.278-0.386,3.662,0.104,3.676,0.108 C107.387,380.508,107.432,380.515,107.476,380.515z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M109.225,382.682c0.205,0,0.376-0.16,0.387-0.368c0.268-5.28-2.532-9.403-2.651-9.577 c-0.121-0.176-0.362-0.221-0.539-0.098c-0.176,0.121-0.22,0.362-0.099,0.538c0.028,0.041,2.77,4.088,2.515,9.098 c-0.011,0.213,0.154,0.396,0.367,0.406C109.212,382.682,109.218,382.682,109.225,382.682z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M111.999,387.211c0.098,0,0.195-0.036,0.271-0.111 c0.153-0.149,0.156-0.394,0.007-0.548c-0.091-0.094-2.266-2.27-5.358-1.306c-0.204,0.064-0.318,0.281-0.254,0.486 c0.064,0.204,0.28,0.318,0.485,0.254c2.644-0.828,4.554,1.087,4.572,1.108 C111.798,387.172,111.898,387.211,111.999,387.211z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M113.418,390.349c0.144,0,0.283-0.082,0.349-0.221c0.053-0.11,1.279-2.739,0.822-6.557 c-0.026-0.212-0.213-0.368-0.431-0.338c-0.212,0.025-0.364,0.218-0.338,0.43c0.429,3.584-0.74,6.107-0.752,6.132 c-0.091,0.194-0.009,0.424,0.184,0.516C113.305,390.337,113.362,390.349,113.418,390.349z"
  })))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M115.921,398.38c0.172,0,0.328-0.115,0.374-0.289c3.035-11.52,10.979-18.765,11.059-18.837 c0.159-0.143,0.172-0.388,0.029-0.547c-0.144-0.16-0.388-0.173-0.547-0.03c-0.082,0.073-8.195,7.464-11.29,19.217 c-0.054,0.207,0.069,0.418,0.276,0.473C115.855,398.376,115.888,398.38,115.921,398.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M122.304,384.52c-0.039-0.197,0.078-0.388,0.265-0.446 c0.022-0.009,0.042-0.017,0.053-0.021c1.455-0.536,3.07-0.778,4.546-0.687c0.213,0.014,0.376,0.197,0.362,0.411 c-0.013,0.214-0.203,0.377-0.411,0.362c-1.371-0.086-2.872,0.14-4.229,0.641l-0.048,0.017 c-0.028,0.011-0.057,0.021-0.083,0.026c-0.026,0.005-0.051,0.008-0.076,0.008 C122.502,384.832,122.34,384.705,122.304,384.52z M122.488,384.112c0.014-0.008,0.049-0.023,0.081-0.037 C122.539,384.084,122.512,384.097,122.488,384.112z M122.606,384.065c0,0,0.001,0,0.001,0 C122.607,384.065,122.607,384.065,122.606,384.065z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M121.132,386.725c0.007,0,0.013,0,0.019-0.001c0.214-0.01,0.378-0.192,0.368-0.405 c-0.216-4.412,2.21-7.944,2.235-7.98c0.123-0.176,0.08-0.417-0.096-0.539c-0.174-0.121-0.417-0.08-0.539,0.095 c-0.106,0.152-2.603,3.776-2.374,8.462C120.756,386.564,120.927,386.725,121.132,386.725z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M119.508,389.255c0.094,0,0.189-0.034,0.263-0.103c0.068-0.062,1.688-1.525,4.005-0.806 c0.205,0.065,0.421-0.052,0.485-0.255c0.064-0.204-0.051-0.421-0.255-0.485c-2.754-0.859-4.682,0.904-4.763,0.979 c-0.156,0.146-0.164,0.39-0.019,0.546C119.301,389.214,119.404,389.255,119.508,389.255z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M117.406,393.451c0.055,0,0.111-0.012,0.165-0.037c0.193-0.091,0.276-0.322,0.186-0.515 c-0.011-0.022-1.036-2.257-0.651-5.404c0.026-0.213-0.125-0.406-0.337-0.431c-0.212-0.033-0.405,0.125-0.431,0.337 c-0.414,3.381,0.673,5.731,0.719,5.829C117.122,393.369,117.261,393.451,117.406,393.451z"
  }))))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M109.802,416.371h12.372c1.319,0,2.435-0.685,2.612-1.603l3.306-17.189h-24.207l3.306,17.189 C107.367,415.686,108.483,416.371,109.802,416.371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M101.871,397.519v3.16h2.611l2.711,14.086c0.171,0.919,1.286,1.604,2.611,1.604h12.371 c1.317,0,2.432-0.685,2.611-1.604l2.711-14.086h3.006v-3.16H101.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M101.871,397.519v3.16h2.611l2.711,14.086c0.171,0.919,1.286,1.604,2.611,1.604h12.371 c1.317,0,2.432-0.685,2.611-1.604l2.711-14.086h3.006v-3.16H101.871z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Resume"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.814,
    y: 66.532,
    style: {
      fill: "#407BFF"
    },
    width: 146.82,
    height: 242.056
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.814,
    y: 66.532,
    style: {
      fill: "#FFFFFF"
    },
    width: 146.82,
    height: 242.056
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 243.629,
    y: 173.868,
    style: {
      fill: "#407BFF"
    },
    width: 0.99,
    height: 127.229
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.896,
    y: 237.102,
    style: {
      fill: "#263238"
    },
    width: 45.037,
    height: 2.369
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.896,
    y: 243.107,
    style: {
      fill: "#263238"
    },
    width: 45.037,
    height: 2.369
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.896,
    y: 249.112,
    style: {
      fill: "#263238"
    },
    width: 45.037,
    height: 2.369
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.896,
    y: 255.117,
    style: {
      fill: "#263238"
    },
    width: 45.037,
    height: 2.369
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.896,
    y: 225.111,
    style: {
      fill: "#407BFF"
    },
    width: 19.588,
    height: 2.369
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.896,
    y: 237.102,
    style: {
      fill: "#407BFF"
    },
    width: 22.518,
    height: 2.369
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.896,
    y: 243.107,
    style: {
      fill: "#407BFF"
    },
    width: 15.286,
    height: 2.369
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.896,
    y: 249.112,
    style: {
      fill: "#407BFF"
    },
    width: 35.928,
    height: 2.369
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.896,
    y: 255.117,
    style: {
      fill: "#407BFF"
    },
    width: 27.296,
    height: 2.369
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 251.557,
    y: 237.694,
    style: {
      fill: "#263238"
    },
    width: 9.522,
    height: 1.185
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 251.557,
    y: 243.699,
    style: {
      fill: "#263238"
    },
    width: 9.522,
    height: 1.185
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 251.557,
    y: 249.704,
    style: {
      fill: "#263238"
    },
    width: 9.522,
    height: 1.184
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 251.557,
    y: 255.709,
    style: {
      fill: "#263238"
    },
    width: 9.522,
    height: 1.185
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M250.935,226.812l0.881,0.143c0.111,0.44,0.284,0.857,0.518,1.247l-0.506,0.709 c-0.094,0.132-0.079,0.313,0.035,0.427l0.938,0.938c0.114,0.114,0.295,0.129,0.427,0.035l0.709-0.507 c0.39,0.234,0.807,0.407,1.247,0.518l0.143,0.881c0.027,0.16,0.165,0.277,0.327,0.277h1.326c0.162,0,0.301-0.117,0.327-0.277 l0.143-0.881c0.44-0.111,0.857-0.284,1.247-0.518l0.71,0.507c0.132,0.094,0.312,0.079,0.427-0.035l0.938-0.938 c0.115-0.115,0.13-0.295,0.035-0.427l-0.506-0.71c0.233-0.39,0.407-0.807,0.518-1.247l0.881-0.143 c0.16-0.026,0.277-0.165,0.277-0.327v-1.327c0-0.162-0.117-0.3-0.277-0.327l-0.881-0.143c-0.11-0.44-0.284-0.857-0.517-1.247 l0.507-0.71c0.094-0.132,0.079-0.313-0.035-0.427l-0.938-0.938c-0.115-0.115-0.296-0.13-0.427-0.035l-0.71,0.506 c-0.39-0.234-0.807-0.407-1.247-0.518l-0.143-0.881c-0.027-0.16-0.165-0.277-0.327-0.277h-1.326 c-0.162,0-0.3,0.117-0.327,0.277l-0.143,0.881c-0.44,0.111-0.857,0.284-1.247,0.518l-0.71-0.506 c-0.132-0.095-0.313-0.08-0.427,0.035l-0.938,0.938c-0.115,0.115-0.13,0.295-0.035,0.427l0.507,0.71 c-0.234,0.39-0.407,0.807-0.518,1.247l-0.881,0.143c-0.16,0.027-0.277,0.165-0.277,0.327v1.327 C250.658,226.647,250.775,226.785,250.935,226.812z M256.318,222.174c2.011,0,3.648,1.636,3.648,3.648 c0,2.011-1.636,3.648-3.648,3.648c-2.011,0-3.648-1.636-3.648-3.648C252.67,223.81,254.306,222.174,256.318,222.174z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#407BFF"
    },
    cx: 256.325,
    cy: 275.952,
    rx: 2.162,
    ry: 2.417
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M253.041,284.08v-1.983c0-1.35,0.995-2.49,2.367-2.867l0.984,0.432l0.858-0.462 c0.585,0.132,1.104,0.406,1.514,0.773c0.607,0.543,0.984,1.292,0.984,2.123v1.983H253.041z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 177.797,
    y: 237.474,
    style: {
      fill: "#407BFF"
    },
    width: 12.533,
    height: 4.557
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 177.797,
    y: 242.748,
    style: {
      fill: "#407BFF"
    },
    width: 12.533,
    height: 3.772
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M186.907,238.638h-0.79v-1.399c0-0.418-0.34-0.758-0.758-0.758h-2.392 c-0.418,0-0.759,0.34-0.759,0.758v1.399h-0.79v-1.399c0-0.854,0.695-1.548,1.549-1.548h2.392c0.854,0,1.548,0.694,1.548,1.548 V238.638z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 250.051,
    y: 173.99,
    style: {
      fill: "#407BFF"
    },
    width: 12.533,
    height: 4.557
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 250.051,
    y: 179.422,
    style: {
      fill: "#407BFF"
    },
    width: 12.533,
    height: 3.614
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M259.161,175.155h-0.79v-1.399c0-0.418-0.34-0.758-0.758-0.758h-2.392 c-0.418,0-0.759,0.34-0.759,0.758v1.399h-0.79v-1.399c0-0.854,0.695-1.548,1.548-1.548h2.392c0.854,0,1.548,0.694,1.548,1.548 V175.155z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M190.379,177.515l-2.148,1.319l-3.554,2.18c-0.284,0.182-0.758,0.182-1.042,0l-3.554-2.18 l-2.148-1.319c-0.292-0.174-0.292-0.466,0-0.64l5.702-2.851c0.284-0.174,0.758-0.174,1.042,0l5.702,2.851 C190.671,177.049,190.671,177.341,190.379,177.515z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M188.231,179.698l0.001,5.319h0c-2.668,0.726-5.482,0.726-8.15,0l0,0l-0.001-5.319l3.554,2.18 c0.284,0.182,0.758,0.182,1.042,0L188.231,179.698z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 189.651,
    y: 177.365,
    style: {
      fill: "#407BFF"
    },
    width: 0.395,
    height: 6.703
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M189.185,183.613c0,0.387,0.314,0.701,0.701,0.701c0.387,0,0.701-0.314,0.701-0.701 c0-0.387-0.314-0.701-0.701-0.701C189.499,182.912,189.185,183.226,189.185,183.613z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.896,
    y: 280.455,
    style: {
      fill: "#407BFF"
    },
    width: 19.588,
    height: 2.369
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 264.896,
    y: 179.234,
    style: {
      fill: "#407BFF"
    },
    width: 19.588,
    height: 2.369
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 253.491,
    y: 288.716,
    style: {
      fill: "#263238"
    },
    width: 56.442,
    height: 1.185
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 253.491,
    y: 293.944,
    style: {
      fill: "#263238"
    },
    width: 56.442,
    height: 1.184
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 253.491,
    y: 299.172,
    style: {
      fill: "#263238"
    },
    width: 11.405,
    height: 1.185
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.757,
    y: 195.686,
    style: {
      fill: "#263238"
    },
    width: 37.813,
    height: 1.185
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.757,
    y: 200.914,
    style: {
      fill: "#263238"
    },
    width: 20.414,
    height: 1.185
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.757,
    y: 213.928,
    style: {
      fill: "#263238"
    },
    width: 37.813,
    height: 1.185
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.757,
    y: 219.156,
    style: {
      fill: "#263238"
    },
    width: 20.414,
    height: 1.184
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.757,
    y: 260.163,
    style: {
      fill: "#263238"
    },
    width: 37.813,
    height: 1.184
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.757,
    y: 265.391,
    style: {
      fill: "#263238"
    },
    width: 20.414,
    height: 1.185
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.757,
    y: 278.434,
    style: {
      fill: "#263238"
    },
    width: 37.813,
    height: 1.185
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.757,
    y: 283.662,
    style: {
      fill: "#263238"
    },
    width: 20.414,
    height: 1.185
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 250.323,
    y: 188.303,
    style: {
      fill: "#263238"
    },
    width: 56.442,
    height: 1.185
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 250.323,
    y: 193.531,
    style: {
      fill: "#263238"
    },
    width: 56.442,
    height: 1.184
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 250.323,
    y: 198.759,
    style: {
      fill: "#263238"
    },
    width: 11.405,
    height: 1.185
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.872,
    y: 179.234,
    style: {
      fill: "#407BFF"
    },
    width: 19.588,
    height: 2.369
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.873,
    y: 188.659,
    style: {
      fill: "#263238"
    },
    width: 40.928,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238"
    },
    cx: 184.163,
    cy: 189.815,
    r: 1.347
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.873,
    y: 206.899,
    style: {
      fill: "#263238"
    },
    width: 40.928,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238"
    },
    cx: 184.163,
    cy: 208.055,
    r: 1.347
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.873,
    y: 225.14,
    style: {
      fill: "#263238"
    },
    width: 40.928,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238"
    },
    cx: 184.163,
    cy: 226.295,
    r: 1.347
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.872,
    y: 243.669,
    style: {
      fill: "#407BFF"
    },
    width: 19.588,
    height: 2.369
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.873,
    y: 253.094,
    style: {
      fill: "#263238"
    },
    width: 40.928,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238"
    },
    cx: 184.163,
    cy: 254.249,
    r: 1.347
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.873,
    y: 271.334,
    style: {
      fill: "#263238"
    },
    width: 40.928,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238"
    },
    cx: 184.163,
    cy: 272.49,
    r: 1.347
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 193.873,
    y: 289.574,
    style: {
      fill: "#263238"
    },
    width: 40.928,
    height: 3
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#263238"
    },
    cx: 184.163,
    cy: 290.73,
    r: 1.347
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.814,
    y: 78.028,
    style: {
      fill: "#407BFF"
    },
    width: 146.82,
    height: 87.822
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.814,
    y: 78.028,
    style: {
      fill: "#FFFFFF"
    },
    width: 146.82,
    height: 87.822
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M195.069,146.139c0,3.316-2.688,6.004-6.004,6.004c-3.316,0-6.004-2.688-6.004-6.004 c0-3.316,2.688-6.004,6.004-6.004C192.381,140.135,195.069,142.823,195.069,146.139z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M211.08,146.139c0,3.316-2.688,6.004-6.004,6.004c-3.316,0-6.004-2.688-6.004-6.004 c0-3.316,2.688-6.004,6.004-6.004C208.391,140.135,211.08,142.823,211.08,146.139z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M226.423,146.139c0,3.316-2.688,6.004-6.004,6.004c-3.316,0-6.004-2.688-6.004-6.004 c0-3.316,2.688-6.004,6.004-6.004C223.735,140.135,226.423,142.823,226.423,146.139z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M241.433,146.139c0,3.316-2.688,6.004-6.004,6.004s-6.004-2.688-6.004-6.004 c0-3.316,2.688-6.004,6.004-6.004S241.433,142.823,241.433,146.139z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 187.48,
    y: 144.936,
    style: {
      fill: "#263238"
    },
    width: 3.114,
    height: 1.223
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M189.4,149.689h-1.223v-5.231c0-0.978,0.796-1.774,1.774-1.774h0.581v1.223h-0.581 c-0.304,0-0.551,0.247-0.551,0.551V149.689z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.838,
    y: 144.259,
    style: {
      fill: "#263238"
    },
    width: 1.223,
    height: 3.972
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 219.727,
    y: 144.35,
    style: {
      fill: "#263238"
    },
    width: 1.223,
    height: 3.881
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M222.418,148.235c0-0.012,0.001-0.05,0.006-0.109c0.118-1.692-0.179-2.244-0.266-2.299 c-0.721-0.043-1.2,0.372-1.371,0.556l-0.896-0.833c0.292-0.314,1.105-1.037,2.365-0.939 c1.082,0.078,1.549,1.289,1.388,3.601L222.418,148.235z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M218.732,143.937h-0.591c-0.177,0-0.321-0.144-0.321-0.321v-0.593 c0-0.177,0.144-0.321,0.321-0.321h0.591c0.177,0,0.321,0.144,0.321,0.321v0.593 C219.053,143.793,218.91,143.937,218.732,143.937z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M205.166,147.837c-0.961,0-1.743-0.782-1.743-1.744s0.782-1.744,1.743-1.744 c0.962,0,1.744,0.782,1.744,1.744S206.127,147.837,205.166,147.837z M205.166,144.96c-0.624,0-1.132,0.508-1.132,1.132 c0,0.624,0.508,1.132,1.132,1.132c0.624,0,1.132-0.508,1.132-1.132C206.298,145.469,205.79,144.96,205.166,144.96z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M206.547,149.74h-2.761c-1.25,0-2.267-1.017-2.267-2.268v-2.761 c0-1.251,1.017-2.268,2.267-2.268h2.761c1.25,0,2.267,1.017,2.267,2.268v2.761 C208.814,148.723,207.797,149.74,206.547,149.74z M203.786,143.056c-0.913,0-1.656,0.743-1.656,1.656v2.761 c0,0.913,0.743,1.656,1.656,1.656h2.761c0.913,0,1.656-0.743,1.656-1.656v-2.761c0-0.913-0.743-1.656-1.656-1.656H203.786z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M233.101,148.327c-0.1,0-0.198-0.039-0.271-0.113c-0.078-0.078-0.117-0.186-0.111-0.292 v-3.319c0-0.211,0.171-0.382,0.382-0.382h1.63c0.608,0,1.103,0.494,1.103,1.102c0,0.305-0.124,0.582-0.326,0.782 c0.329,0.214,0.546,0.586,0.546,1.006c0,0.324-0.127,0.629-0.358,0.856c-0.231,0.227-0.534,0.34-0.86,0.345 c-1.178-0.019-1.523-0.008-1.624-0.002C233.175,148.322,233.138,148.327,233.101,148.327z M233.71,147.536 c0.279,0,0.648,0.005,1.137,0.012c0.097-0.002,0.228-0.042,0.312-0.125c0.084-0.082,0.13-0.193,0.13-0.312 c0-0.241-0.196-0.437-0.437-0.437h-1.37v0.862C233.551,147.537,233.626,147.536,233.71,147.536z M233.483,145.662h1.248 c0.187,0,0.338-0.152,0.338-0.339c0-0.186-0.152-0.338-0.338-0.338h-1.248V145.662z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M238.667,146.983h-2.07c-0.21,0-0.381-0.17-0.382-0.38c0-0.074,0.009-0.736,0.472-1.159 c0.188-0.173,0.525-0.367,1.066-0.314c0.468,0.045,0.821,0.221,1.05,0.523c0.332,0.438,0.252,0.957,0.241,1.014 C239.011,146.85,238.852,146.983,238.667,146.983z M237.061,146.219h1.19c-0.015-0.037-0.035-0.074-0.061-0.107 c-0.095-0.122-0.267-0.197-0.511-0.22c-0.21-0.021-0.367,0.018-0.477,0.118 C237.14,146.066,237.094,146.141,237.061,146.219z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M237.682,148.282c-0.711,0-1.436-0.511-1.452-1.651l-0.005-0.382l0.764-0.011l0.005,0.382 c0.011,0.832,0.529,0.897,0.687,0.897c0.284,0,0.411-0.069,0.461-0.11l-0.004-0.266l0.764-0.032l0.005,0.382 c0.001,0.039-0.004,0.098-0.016,0.136C238.873,147.694,238.669,148.282,237.682,148.282z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 184.248,
    y: 108.327,
    style: {
      fill: "#263238"
    },
    width: 53.317,
    height: 2.369
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 184.248,
    y: 116.768,
    style: {
      fill: "#263238"
    },
    width: 26.658,
    height: 2.369
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 184.248,
    y: 125.802,
    style: {
      fill: "#263238"
    },
    width: 53.317,
    height: 1.185
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 184.248,
    y: 134.244,
    style: {
      fill: "#263238"
    },
    width: 26.658,
    height: 1.184
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M192.505,94.55v7.853h-2.221V99.34h-3.029v3.063h-2.221V94.55h2.221V97.5h3.029V94.55H192.505z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M200.156,99.901h-4.42c0.18,0.617,0.707,0.976,1.492,0.976c0.595,0,0.987-0.169,1.402-0.527 l1.122,1.167c-0.583,0.651-1.436,0.987-2.592,0.987c-2.165,0-3.567-1.335-3.567-3.153c0-1.828,1.424-3.129,3.343-3.129 c1.795,0,3.254,1.144,3.254,3.152C200.19,99.531,200.167,99.733,200.156,99.901z M195.702,98.779h2.491 c-0.112-0.639-0.583-1.043-1.245-1.043C196.286,97.736,195.826,98.14,195.702,98.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M201.177,94.078h2.132v8.324h-2.132V94.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M204.689,94.078h2.132v8.324h-2.132V94.078z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M207.818,99.351c0-1.828,1.447-3.129,3.433-3.129c2.008,0,3.433,1.301,3.433,3.129 c0,1.84-1.425,3.153-3.433,3.153C209.266,102.504,207.818,101.191,207.818,99.351z M212.53,99.351 c0-0.92-0.55-1.436-1.279-1.436c-0.718,0-1.279,0.516-1.279,1.436c0,0.932,0.561,1.458,1.279,1.458 C211.98,100.81,212.53,100.283,212.53,99.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M215.402,101.325c0-0.662,0.527-1.155,1.279-1.155c0.752,0,1.268,0.494,1.268,1.155 c0,0.651-0.516,1.178-1.268,1.178C215.929,102.504,215.402,101.976,215.402,101.325z M215.413,94.55h2.535l-0.426,4.993 h-1.694L215.413,94.55z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 170.814,
    y: 66.532,
    style: {
      fill: "#407BFF"
    },
    width: 146.82,
    height: 11.495
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M264.602,137.338c4.658-5.668,3.103-12.132,3.103-12.132h-1.736l-2.949,2.24v0 C263.505,130.354,264.083,133.907,264.602,137.338z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M266.116,166.053c0,0,0.142-10.567-0.053-16.13c-0.026-0.732-0.058-1.38-0.095-1.902 c-0.432-5.989-3.219-22.251-3.888-26.107c-0.105-0.59,0.121-1.18,0.569-1.57c0.658-0.569,1.475-1.033,2.413-1.391 c1.97-0.769,4.478-1.112,7.212-1.175c1.775-0.042,3.64,0.026,5.51,0.179c0.385,0.032,0.774,0.063,1.159,0.105 c1.733,0.163,3.456,0.39,5.099,0.648c0.732,0.111,1.449,0.227,2.144,0.348c1.08,0.19,2.107,0.384,3.061,0.579 c2.149,0.432,3.914,0.843,5.025,1.122c0.031,0.005,0.068,0.011,0.1,0.021c0.306,0.074,0.574,0.237,0.78,0.453 c0,0.005,0.005,0.005,0.005,0.005c0.263,0.29,0.421,0.669,0.421,1.08l0.053,23.405l0.011,4.862l0.032,15.561 L266.116,166.053z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M283.64,124.395c-0.024,0.635-0.559,1.131-1.194,1.107c-0.635-0.024-1.131-0.559-1.107-1.194 c0.024-0.635,0.559-1.131,1.194-1.107C283.168,123.225,283.664,123.76,283.64,124.395z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M284.889,134.229c-0.024,0.635-0.558,1.131-1.194,1.107c-0.635-0.024-1.131-0.559-1.107-1.194 c0.024-0.635,0.559-1.131,1.194-1.107C284.417,133.059,284.913,133.594,284.889,134.229z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M285.591,146.12c-0.024,0.635-0.558,1.131-1.194,1.107c-0.635-0.024-1.131-0.558-1.107-1.194 c0.024-0.635,0.559-1.131,1.194-1.107C285.119,144.95,285.615,145.485,285.591,146.12z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M285.142,157.967c-0.024,0.635-0.558,1.131-1.194,1.107c-0.635-0.024-1.131-0.558-1.107-1.194 c0.024-0.635,0.559-1.131,1.194-1.107C284.671,156.798,285.167,157.332,285.142,157.967z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M276.554,116.308l1.483,1.993l2.886,1.911l1.727,0.433l2.69-0.805l1.18-0.123l0.24-0.184 c-2.692-1.945-2.502-5.129-1.511-7.869l-7.566-7.928C277.995,107.168,278.074,112.753,276.554,116.308z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M284.588,114.737c0.05-1.029,0.301-2.08,0.66-3.073l-4.631-4.853l-2.81-1.303l0,0.001 c0.061,1.189,0.082,2.507,0.029,3.85C278.788,111.305,280.722,113.755,284.588,114.737z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M287.174,93.926c0,0,4.738,0.896,3.961-2.724c0,0-0.278,1.056-5.476,0.561 S287.174,93.926,287.174,93.926z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M287.174,93.926c0,0,4.738,0.896,3.961-2.724c0,0-0.278,1.056-5.476,0.561S287.174,93.926,287.174,93.926z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M276.619,98.935c0.143,5.253-0.033,8.332,2.525,11.105 c3.842,4.181,10.395,1.981,11.813-3.194c1.284-4.694,0.822-12.473-4.238-14.727c-3.603-1.628-7.843-0.026-9.471,3.577 C276.789,96.712,276.574,97.821,276.619,98.935z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M284.768,100.722c-0.014,0.429,0.198,0.783,0.479,0.791c0.28,0.008,0.515-0.328,0.529-0.758 c0.014-0.429-0.2-0.778-0.48-0.785C285.015,99.963,284.78,100.299,284.768,100.722z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M289.587,100.884c-0.012,0.423,0.2,0.778,0.48,0.785c0.28,0.008,0.515-0.328,0.527-0.752 c0.012-0.423-0.198-0.783-0.479-0.791S289.6,100.455,289.587,100.884z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M283.176,98.667c-0.043-0.002-0.085-0.012-0.124-0.031c-0.103-0.09-0.119-0.245-0.037-0.354 c0.496-0.635,1.267-0.995,2.073-0.966c0.138,0.014,0.239,0.137,0.225,0.276c-0.014,0.139-0.137,0.24-0.276,0.226l0,0 c-0.638-0.016-1.245,0.274-1.632,0.782C283.346,98.66,283.259,98.686,283.176,98.667z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M291.527,99c-0.084-0.013-0.156-0.069-0.189-0.148c-0.241-0.586-0.746-1.022-1.361-1.175 c-0.136-0.022-0.229-0.151-0.207-0.287c0.022-0.136,0.151-0.229,0.287-0.207c0.789,0.179,1.444,0.728,1.756,1.475 c0.056,0.122,0.003,0.266-0.119,0.323c-0.002,0.001-0.004,0.002-0.007,0.003C291.637,99.008,291.581,99.014,291.527,99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M287.314,106.959c0.286,0.031,0.575,0.037,0.863,0.016c0.083-0.005,0.146-0.076,0.141-0.158 c0-0.002,0-0.003,0-0.005c-0.005-0.082-0.075-0.144-0.156-0.14c-1.289,0.113-2.556-0.391-3.416-1.358 c-0.05-0.068-0.145-0.082-0.213-0.033c-0.068,0.05-0.082,0.145-0.033,0.213 C285.213,106.328,286.222,106.853,287.314,106.959z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA4D3C"
    },
    d: "M288.365,100.657c0.454,1.284,1.083,2.499,1.87,3.611c-0.775,0.66-1.999,0.31-1.999,0.31 L288.365,100.657z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M272.075,118.341c0.141-1.201,2.604-3.258,4.014-2.699c1.41,0.559,3.749,4.083,6.027,4.225 c2.278,0.142,2.798-4.034,4-3.621c1.202,0.413,2.583,1.656,2.945,2.562c0.418,1.045,0.396,4.96-0.677,4.452 c0,0-1.472-2.793-2.4-3.124c-0.865-0.309-2.658,0.831-3.577,0.836c-0.996,0.005-2.988-1.225-3.899-0.822 c-0.916,0.404-1.743,2.964-2.743,2.918C274.268,122.998,271.9,119.829,272.075,118.341z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M272.075,118.341c0.141-1.201,2.604-3.258,4.014-2.699c1.41,0.559,3.749,4.083,6.027,4.225 c2.278,0.142,2.798-4.034,4-3.621c1.202,0.413,2.583,1.656,2.945,2.562c0.418,1.045,0.396,4.96-0.677,4.452 c0,0-1.472-2.793-2.4-3.124c-0.865-0.309-2.658,0.831-3.577,0.836c-0.996,0.005-2.988-1.225-3.899-0.822 c-0.916,0.404-1.743,2.964-2.743,2.918C274.268,122.998,271.9,119.829,272.075,118.341z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M286.61,144.861c3.516,1.524,6.34-1.649,6.34-1.649l-5.047-3.81l-2.373,3.599L286.61,144.861 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CE7A63"
    },
    points: "287.904,139.402 292.941,143.203 294.774,140.737 292.651,137.44  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M261.562,123.066c-0.011,2.744,0.037,5.473,0.137,8.223c0.079,2.081,0.169,4.156,0.321,6.237 c0.153,2.076,0.306,4.177,0.564,6.295l0.084,0.78l0.042,0.395l0.1,0.653c0.105,0.58,0.279,1.143,0.527,1.675 c0.384,0.827,0.974,1.538,1.717,2.065c0.806,0.553,1.754,0.853,2.734,0.859c0.632,0.011,1.27-0.084,1.875-0.285 l17.753-4.783c0,0-1.227-2.955-1.017-3.292c-0.985,0.163-10.33,0.853-16.372,1.285l0.079-1.517 c0.026-0.701,0.743-17.668,0.743-17.668c-0.005-2.291-2.745-5.062-5.031-5.094 C263.484,118.862,261.567,120.738,261.562,123.066z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M261.562,123.066c-0.011,2.744,0.037,5.473,0.137,8.223c0.079,2.081,0.169,4.156,0.321,6.237 c0.153,2.076,0.306,4.177,0.564,6.295l0.084,0.78l0.042,0.395l0.1,0.653c0.105,0.58,0.279,1.143,0.527,1.675 c0.384,0.827,0.974,1.538,1.717,2.065c0.806,0.553,1.754,0.853,2.734,0.859c0.632,0.011,1.27-0.084,1.875-0.285 l17.753-4.783c0,0-1.227-2.955-1.017-3.292c-0.985,0.163-10.33,0.853-16.372,1.285l0.079-1.517 c0.026-0.701,0.743-17.668,0.743-17.668c-0.005-2.291-2.745-5.062-5.031-5.094 C263.484,118.862,261.567,120.738,261.562,123.066z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M286.399,141.888c0.069-0.01,0.095-0.021,0.074-0.026 C286.436,141.851,286.41,141.862,286.399,141.888z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M277.307,103.302c0,0,1.963-0.96,1.961-4.806c0,0,2.045-1.188,2.207-3.812 c0,0,9.972-0.993,8.404-4.532c-1.568-3.539-8.581-4.861-8.581-4.861s2.04,3.567-4.459,6.344 c-6.5,2.777-1.331,11.378-1.331,11.378L277.307,103.302z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M274.134,95.019c0,0-2.926-1.944-1.775-3.073C273.51,90.817,274.134,95.019,274.134,95.019z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M273.897,103.739c0.669,1.137,1.759,1.964,3.034,2.304c1.699,0.426,2.507-1.095,2.001-2.677 c-0.453-1.418-1.885-3.357-3.57-3.09C273.676,100.542,273.091,102.326,273.897,103.739z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M276.666,145.205c-3.516,1.524-6.34-1.649-6.34-1.649l5.047-3.81l2.373,3.599L276.666,145.205 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CE7A63"
    },
    points: "275.373,139.745 270.335,143.546 268.502,141.08 270.625,137.784  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M300.694,144.166l-0.084,0.78l-0.042,0.395l-0.1,0.653c-0.105,0.579-0.279,1.143-0.527,1.675 c-0.384,0.827-0.974,1.538-1.717,2.065c-0.764,0.521-1.654,0.822-2.581,0.853c-0.047,0.005-0.1,0.005-0.153,0.005 c-0.632,0.011-1.27-0.084-1.875-0.284l-12.611-3.398l-5.141-1.385c0,0,0.005-0.016,0.021-0.053 c0.126-0.311,0.801-1.97,0.975-2.797c0.047-0.216,0.063-0.379,0.021-0.443c0.037,0.005,0.084,0.016,0.147,0.021 c0.39,0.053,1.264,0.132,2.439,0.227c1.612,0.137,3.793,0.305,6.1,0.474c0.342,0.026,0.69,0.053,1.043,0.079 c2.081,0.158,4.209,0.311,6.079,0.442c0.19,0.016,1.349,0.055,1.533,0.071l-1.896-19.214c0-0.063,0.105-0.126,0.116-0.19 c0.063-1.059,0.685-2.191,1.554-3.103c0.09-0.1,0.184-0.19,0.279-0.279c0.031,0.005,0.068,0.011,0.1,0.021 c0.792-0.053,1.487,0.211,2.074,0.589c1.207,0.778,1.965,2.089,2.148,3.514C299.204,129.611,300.866,142.743,300.694,144.166 z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M300.694,144.166l-0.084,0.78l-0.042,0.395l-0.1,0.653c-0.105,0.579-0.279,1.143-0.527,1.675 c-0.384,0.827-0.974,1.538-1.717,2.065c-0.764,0.521-1.654,0.822-2.581,0.853c-0.047,0.005-0.1,0.005-0.153,0.005 c-0.632,0.011-1.27-0.084-1.875-0.284l-12.611-3.398l-5.141-1.385c0,0,0.005-0.016,0.021-0.053 c0.126-0.311,0.801-1.97,0.975-2.797c0.047-0.216,0.063-0.379,0.021-0.443c0.037,0.005,0.084,0.016,0.147,0.021 c0.39,0.053,1.264,0.132,2.439,0.227c1.612,0.137,3.793,0.305,6.1,0.474c0.342,0.026,0.69,0.053,1.043,0.079 c2.081,0.158,4.209,0.311,6.079,0.442c0.19,0.016,1.349,0.055,1.533,0.071l-1.896-19.214c0-0.063,0.105-0.126,0.116-0.19 c0.063-1.059,0.685-2.191,1.554-3.103c0.09-0.1,0.184-0.19,0.279-0.279c0.031,0.005,0.068,0.011,0.1,0.021 c0.792-0.053,1.487,0.211,2.074,0.589c1.207,0.778,1.965,2.089,2.148,3.514C299.204,129.611,300.866,142.743,300.694,144.166 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M276.877,142.232c-0.069-0.01-0.095-0.021-0.074-0.026 C276.84,142.195,276.866,142.205,276.877,142.232z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M182.815,72.348c0,0.907-0.736,1.643-1.643,1.643c-0.907,0-1.643-0.736-1.643-1.643 c0-0.907,0.736-1.643,1.643-1.643C182.08,70.705,182.815,71.44,182.815,72.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M189.123,72.348c0,0.907-0.735,1.643-1.643,1.643s-1.643-0.736-1.643-1.643 c0-0.907,0.736-1.643,1.643-1.643S189.123,71.44,189.123,72.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M195.431,72.348c0,0.907-0.735,1.643-1.643,1.643s-1.643-0.736-1.643-1.643 c0-0.907,0.736-1.643,1.643-1.643S195.431,71.44,195.431,72.348z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CE7A63"
    },
    points: "340.716,392.953 339.289,409.588 330.362,409.065 331.022,391.777  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CE7A63"
    },
    points: "416.914,386.975 423.757,402.064 415.922,406.596 408.11,391.374  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M357.398,243.284c0,0-20.518,67.01-24.441,87.531c-3.101,16.222-3.324,66.235-3.324,66.235 l11.93,1.029c0,0,2.746-24.137,5.512-44.11c1.21-8.737,3.026-16.681,4.507-21.454c4.857-15.649,22.557-42.441,28.232-57.762 c1.96-5.293,2.578-30.677,2.578-30.677L357.398,243.284z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "343.643,395.152 327.981,393.84 328.004,399.921 342.618,400.965  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M371.552,265.431l10.524,8.802c-2.446,4.754-12.842,20.915-16.315,26.533 C364.557,287.305,371.552,265.431,371.552,265.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M361.109,243.284c0,0,12.764,75.932,19.456,97.095c4.765,15.068,29.343,56.173,29.343,56.173 l9.744-5.385c0,0-9.292-22.308-15.741-39.629c-2.2-5.909-4.859-11.242-5.636-14.905c-3.321-15.651-2.021-48.031-2.928-64.03 c-0.288-5.075-1.692-28.726-1.692-28.726L361.109,243.284z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "419.637,387.165 422.192,392.621 409.697,399.591 406.844,394.293  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M326.877,409.348c-1.029-0.012-2.092-0.227-2.432-0.705c-0.176-0.28-0.169-0.647,0.016-0.915 c0.139-0.243,0.361-0.417,0.618-0.485c1.382-0.392,4.267,1.412,4.394,1.492c0.072,0.045,0.109,0.133,0.094,0.22 c-0.016,0.086-0.078,0.153-0.159,0.171C328.573,409.279,327.726,409.354,326.877,409.348z M325.563,407.604 c-0.127-0.004-0.253,0.012-0.375,0.048c-0.163,0.028-0.305,0.135-0.385,0.29c-0.146,0.26-0.095,0.387-0.039,0.46 c0.383,0.583,2.47,0.622,4.01,0.435C327.784,408.212,326.694,407.794,325.563,407.604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M329.378,409.122c-0.027,0.008-0.056,0.005-0.082-0.009c-0.989-0.483-2.975-2.432-2.797-3.429 c0.021-0.241,0.19-0.532,0.73-0.583c0.394-0.04,0.788,0.094,1.091,0.372c1.052,0.942,1.27,3.341,1.281,3.452 c0.005,0.076-0.029,0.148-0.088,0.189C329.47,409.135,329.422,409.138,329.378,409.122z M327.359,405.501l-0.112-0.012 c-0.352,0.028-0.376,0.18-0.391,0.234c-0.051,0.602,1.25,2.124,2.275,2.787c-0.097-1.008-0.479-1.964-1.095-2.736 C327.848,405.598,327.608,405.501,327.359,405.501L327.359,405.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M330.255,407.892l9.033,0.107c0.34,0.004,0.635,0.26,0.709,0.618l1.622,7.908 c0.149,0.7-0.259,1.392-0.91,1.545c-0.084,0.02-0.169,0.03-0.254,0.03c-3.256-0.099-6.151-0.325-10.206-0.366 c-4.784-0.055-3.571,0.574-9.196,0.594c-3.389,0.008-4.003-4.134-2.566-4.321c6.578-0.811,7.264-2.935,9.804-5.432 C328.844,408.095,329.543,407.852,330.255,407.892z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M413.147,408.396c-0.911,0.503-1.941,0.844-2.448,0.588c-0.276-0.161-0.429-0.49-0.382-0.822 c0.017-0.285,0.137-0.551,0.334-0.741c1.048-1.039,4.37-0.876,4.517-0.868c0.083,0.004,0.154,0.064,0.179,0.149 c0.023,0.085-0.003,0.175-0.066,0.231C414.611,407.487,413.897,407.977,413.147,408.396z M411.234,407.501 c-0.113,0.06-0.217,0.137-0.31,0.23c-0.132,0.106-0.21,0.272-0.213,0.45c-0.016,0.304,0.084,0.392,0.165,0.428 c0.59,0.327,2.445-0.682,3.72-1.617C413.453,406.932,412.313,407.105,411.234,407.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M415.252,406.945c-0.02,0.021-0.047,0.033-0.076,0.033c-1.08,0.065-3.674-0.677-3.95-1.652 c-0.086-0.224-0.064-0.568,0.389-0.884c0.33-0.233,0.735-0.31,1.122-0.214c1.336,0.312,2.567,2.337,2.625,2.431 c0.038,0.065,0.039,0.146,0.005,0.212C415.339,406.911,415.297,406.937,415.252,406.945z M411.904,404.733l-0.104,0.045 c-0.298,0.201-0.253,0.348-0.243,0.403c0.216,0.561,2.022,1.264,3.212,1.342c-0.522-0.848-1.273-1.507-2.151-1.887 C412.376,404.575,412.122,404.609,411.904,404.733L411.904,404.733z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M415.491,405.412l8.001-4.419c0.302-0.167,0.672-0.086,0.893,0.195l4.857,6.223 c0.435,0.549,0.376,1.368-0.131,1.829c-0.065,0.059-0.136,0.111-0.211,0.154c-2.911,1.539-5.558,2.785-9.146,4.774 c-4.237,2.342-2.896,2.295-7.841,5.123c-2.981,1.701-5.318-1.677-4.134-2.561c5.441-4.009,5.124-6.24,6.279-9.731 C414.336,406.298,414.846,405.733,415.491,405.412z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M340.106,194.424l-8.748,5.52c-0.564,0.595-18.572-16.873-18.572-16.873 s-0.616-5.434-0.862-6.316l-0.609-2.186c-0.068-0.244-0.109-0.494-0.124-0.746l-0.003-0.059 c-0.107-1.869-1.654-3.33-3.526-3.332l0,0c-0.701-0.001-1.387,0.208-1.969,0.598l-4.098,2.745 c-1.214,0.813-1.803,2.29-1.481,3.715l9.057,7.737c0,0,12.487,23.524,18.85,27.225c5.873,3.417,18.544-10.354,18.544-10.354 L340.106,194.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M355.934,187.208c-1.468-1.632-3.054-3.055-6.203-2.832 c-4.882,0.346-14.475,11.271-14.475,11.271l8.678,13.817c0,0,11.382-10.029,13.217-14.177 C358.585,192.047,357.72,189.193,355.934,187.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M355.934,187.208c-1.468-1.632-3.054-3.055-6.203-2.832 c-4.882,0.346-14.475,11.271-14.475,11.271l8.678,13.817c0,0,11.382-10.029,13.217-14.177 C358.585,192.047,357.72,189.193,355.934,187.208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M348.843,204.915c-0.347-5.497-0.548-11.502-0.548-11.502l4.165,7.868 C351.28,202.527,350.022,203.778,348.843,204.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M366.441,185.227l-4.428-1.533c0.028-1.251-0.351-2.518-0.939-3.765 c-0.369-0.77-0.782-1.519-1.239-2.241l4.188-7.063l3.081-5.18c0.606,5.16,2.354,13.902,6.253,17.161L366.441,185.227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M359.835,177.688c0.457,0.732,0.871,1.49,1.239,2.27 c2.058-1.239,4.176-4.66,3.678-7.035c-0.156-0.791-0.401-1.562-0.729-2.298L359.835,177.688z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M394.565,187.704l-1.073,57.353l-4.027,0.609c-10.833,1.639-21.893,0.896-32.41-2.175h0 l-9.6-54.283c-0.508-2.539,1.408-4.918,3.998-4.964l38.889-0.679C392.657,183.525,394.558,185.388,394.565,187.704z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M394.565,187.704l-1.073,57.353l-4.027,0.609c-10.833,1.639-21.893,0.896-32.41-2.175 l-9.6-54.283c-0.508-2.539,1.408-4.918,3.998-4.964l38.889-0.679C392.657,183.525,394.558,185.388,394.565,187.704z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M393.953,216.973c-11.065-12.775-11.065-22.037-11.065-22.037l11.614,3.62L393.953,216.973z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M354.261,152.069c0,0-7.271,0.955-5.748-4.608c0,0,0.322,1.669,8.252,1.382 C364.695,148.556,354.261,152.069,354.261,152.069z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9
    },
    d: "M354.261,152.069c0,0-7.271,0.955-5.748-4.608c0,0,0.322,1.669,8.252,1.382 C364.695,148.556,354.261,152.069,354.261,152.069z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M369.838,161.274c-1.736,7.392-2.365,11.795-6.8,15.109 c-4.326,3.311-10.518,2.488-13.829-1.838c-1.218-1.592-1.923-3.518-2.02-5.52c-0.475-6.913,2.437-17.843,10.274-19.817 c5.306-1.492,10.817,1.6,12.309,6.905C370.247,157.798,370.269,159.577,369.838,161.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M358.117,161.832c-0.097,0.606-0.51,1.048-0.905,0.961c-0.394-0.087-0.634-0.587-0.537-1.193 c0.096-0.606,0.51-1.057,0.914-0.961C357.993,160.736,358.223,161.226,358.117,161.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M351.224,160.904c-0.097,0.606-0.501,1.048-0.905,0.961c-0.404-0.087-0.634-0.587-0.537-1.202 c0.097-0.615,0.51-1.047,0.914-0.961C351.1,159.788,351.331,160.288,351.224,160.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA4D3C"
    },
    d: "M353.368,161.501c-1.047,1.761-2.322,3.377-3.792,4.804c0.903,1.145,2.816,0.964,2.816,0.964 L353.368,161.501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M358.169,167.428c-1.205,1.166-2.887,1.7-4.544,1.443c-0.102-0.034-0.212,0.021-0.246,0.123 c-0.034,0.102,0.021,0.213,0.123,0.246c0.023,0.008,0.048,0.011,0.072,0.01c0.254,0.044,0.511,0.068,0.769,0.072 c1.533,0.042,3.016-0.546,4.103-1.627c0.07-0.075,0.07-0.192,0-0.267"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M360.628,159.902c0.057,0.014,0.116,0.014,0.173,0c0.176-0.087,0.249-0.3,0.161-0.477 c-0.002-0.005-0.005-0.009-0.007-0.014c-0.514-1.046-1.516-1.768-2.671-1.925c-0.196-0.016-0.368,0.129-0.384,0.325 c0,0.004-0.001,0.007-0.001,0.011c-0.016,0.196,0.129,0.368,0.325,0.384c0.004,0,0.008,0.001,0.011,0.001 c0.896,0.129,1.674,0.686,2.085,1.492C360.374,159.822,360.495,159.901,360.628,159.902z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M348.669,158.142c0.119,0.003,0.232-0.055,0.298-0.154c0.519-0.783,1.372-1.28,2.309-1.344 c0.199-0.033,0.334-0.22,0.302-0.419c-0.025-0.155-0.147-0.276-0.301-0.302l0,0c-1.168,0.065-2.238,0.677-2.886,1.651 c-0.115,0.16-0.078,0.382,0.081,0.497c0.002,0.001,0.003,0.002,0.005,0.004C348.532,158.118,348.599,158.141,348.669,158.142 z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    points: "369.965,187.643 367.656,192.261 366.966,193.263 370.589,230.118  365.757,234.395 360.932,229.452 364.802,193.261 364.035,191.809 361.953,187.637 363.601,185.223 367.882,184.263  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "374.287,180.811 366.278,183.893 359.792,181.066 356.369,184.949 359.716,192.965  366.33,186.091 372.883,193.267 377.576,184.301  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3
    },
    points: "374.287,180.811 366.278,183.893 359.792,181.066 356.369,184.949 359.716,192.965  366.33,186.091 372.883,193.267 377.576,184.301  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M402.331,200.973c0,0,8.8,11.964,8.519,16.625c-0.449,7.455-16.72,24.758-16.72,24.758 l-2.041,6.516c-0.255,0.815-0.817,1.499-1.566,1.909l-5.232,2.858c-1.515,0.828-3.413,0.346-4.35-1.104l-1.21-1.871 c-0.805-1.245-0.681-2.873,0.304-3.981l2.042-2.299c0.098-0.11,0.203-0.213,0.314-0.309l6.695-4.533 c0,0,5.25-9.345,8.132-16.078c1.077-2.515,1.81-4.827,1.793-6.431c-0.038-3.571-6.343-12.801-6.343-12.801L402.331,200.973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M385.025,184.365c1.792-1.268,5.952-1.001,7.902,0.006c5.151,2.658,13.449,18.01,13.449,18.01 l-14.933,8.183c0,0-8.921-13.419-9.351-18.739C381.914,189.624,383.221,185.642,385.025,184.365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M385.025,184.365c1.792-1.268,5.952-1.001,7.902,0.006c5.151,2.658,13.449,18.01,13.449,18.01 l-14.933,8.183c0,0-8.921-13.419-9.351-18.739C381.914,189.624,383.221,185.642,385.025,184.365z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 291.632,
    y: 178.112,
    transform: "matrix(0.9857 -0.1685 0.1685 0.9857 -25.9119 51.9488)",
    style: {
      fill: "#263238"
    },
    width: 2.961,
    height: 1.057
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.632,
    y: 178.112,
    transform: "matrix(0.9857 -0.1685 0.1685 0.9857 -25.9119 51.9488)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    width: 2.961,
    height: 1.057
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 294.213,
    y: 176.845,
    transform: "matrix(0.9857 -0.1685 0.1685 0.9857 -25.6523 52.942)",
    style: {
      fill: "#263238"
    },
    width: 9.847,
    height: 1.565
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.213,
    y: 176.845,
    transform: "matrix(0.9857 -0.1685 0.1685 0.9857 -25.6523 52.942)",
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 9.847,
    height: 1.565
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 303.073,
    y: 174.944,
    transform: "matrix(0.9857 -0.1685 0.1685 0.9857 -25.2183 54.6037)",
    style: {
      fill: "#263238"
    },
    width: 12.193,
    height: 1.937
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.073,
    y: 174.944,
    transform: "matrix(0.9857 -0.1685 0.1685 0.9857 -25.2183 54.6037)",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 12.193,
    height: 1.937
  })), /*#__PURE__*/React.createElement("rect", {
    x: 314.961,
    y: 173.643,
    transform: "matrix(0.9857 -0.1685 0.1685 0.9857 -24.9441 55.6772)",
    style: {
      fill: "#407BFF"
    },
    width: 1.259,
    height: 2.343
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M368.332,167.578c0,0-2.885-1.676-2.516-7.662c0,0-2.988-2.039-2.984-6.138 c0,0-15.03-2.471-12.315-7.834c2.716-5.363,13.477-6.77,13.477-6.77s-3.434,5.362,6.159,10.288 c9.593,4.926,0.934,17.832,0.934,17.832L368.332,167.578z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M373.933,154.98c0,0,4.622-2.753,2.984-4.618C375.28,148.498,373.933,154.98,373.933,154.98z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M371.611,167.958c-0.761,1.517-2.067,2.69-3.656,3.285c-2.087,0.758-3.182-1.089-2.642-3.146 c0.492-1.865,2.167-4.488,4.282-4.352C371.711,163.881,372.536,166.074,371.611,167.958z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume);
export default __webpack_public_path__ + "static/media/resume.aae17b3659fb822dc29cf24c19cb6ea8.svg";
export { ForwardRef as ReactComponent };